module.exports = __webpack_public_path__ + "media/gnoll.896cbe6c.mp3";